import React, { Component } from 'react';
import { LayoutContentWithHeader, Tabs, parseQuery, Col } from '@jjj/components';
import { withRouter } from 'src/containers/withRouter/withRouter';
import { connect } from 'react-redux';
import { isArray } from 'lodash';
import { Wrapper } from './penaltyRatesSection.style';
import { t } from '../../../../../../i18n';
import PenaltyRates from './penaltyRates';
import actions from '../../actions';

export const PENALTY_RATES_TABS = {
  CURRENT: 'current',
  FUTURE: 'future',
};

class PenaltyRatesSection extends Component {
  state = {
    tab: PENALTY_RATES_TABS.CURRENT,
  };

  componentDidMount() {
    this.historyListener = this.props.history.listen(location => {
      const { search = '' } = location;
      const query = parseQuery(search);

      if (query.tab) {
        this.setState({ tab: query.tab });
      }
    });

    const { tab } = this.state;

    if (tab) {
      this.setState({ tab }, () => {
        this.loadPenaltyRates(tab);
      });
    } else {
      this.loadPenaltyRates(PENALTY_RATES_TABS.CURRENT);
    }
  }

  componentDidUpdate() {
    const { data, shouldForceChangePenaltyRateTab } = this.props;

    if (data.shouldForceChangePenaltyRateTab) {
      this.forceToOpenTab();
      shouldForceChangePenaltyRateTab();
    }
  }

  onTabChange(tab) {
    this.setState({ tab });
    this.loadPenaltyRates(tab);
  }

  forceToOpenTab() {
    const { editForm } = this.props.data;
    const { tab } = this.state;

    function hasError(penaltyRates) {
      let error = false;

      penaltyRates.forEach(rate => {
        Object.keys(rate).forEach(field => {
          if (rate[field].error !== '' && rate[field].error?.length > 0) {
            error = true;
          }
        });
      });

      return error;
    }

    const currentTabHasErrors =
      isArray(editForm.current_penalty_rates_group) && hasError(editForm.current_penalty_rates_group);
    const futureTabHasErrors =
      isArray(editForm.future_penalty_rates_group) && hasError(editForm.future_penalty_rates_group);

    if (currentTabHasErrors && tab !== PENALTY_RATES_TABS.CURRENT) {
      this.setState({ tab: PENALTY_RATES_TABS.CURRENT });
    } else if (futureTabHasErrors && !currentTabHasErrors && tab !== PENALTY_RATES_TABS.FUTURE) {
      this.setState({ tab: PENALTY_RATES_TABS.FUTURE });
    }
  }

  loadPenaltyRates(tab) {
    const { id } = this.props.match.params;
    const { data } = this.props;
    const { sector, editForm } = data;

    if (
      (!editForm?.[`${tab}_penalty_rates_group`]?.length || sector?.[`${tab}_penalty_rates_group`]?.id) &&
      sector?.[`contains_${tab}_group`]
    ) {
      this.props.loadSectorPenaltyRates({ sector, id, tab, addDefaultOne: true });
    }
  }

  render() {
    const { tab } = this.state;
    const { baseErrors } = this.props.data;

    return (
      <Wrapper>
        <LayoutContentWithHeader
          header={this.props.header}
          icon="clipboard-list"
          style={{ marginBottom: 16 }}
          padding="30px"
        >
          <Tabs
            onChange={newTab => this.onTabChange(newTab)}
            activeKey={tab}
            destroyOnHidden
            items={[
              {
                label: t('dash.common.constants.current'),
                key: PENALTY_RATES_TABS.CURRENT,
                children: <PenaltyRates type={PENALTY_RATES_TABS.CURRENT} forceToOpenTab={this.forceToOpenTab} />,
              },
              {
                label: t('dash.common.constants.future'),
                key: PENALTY_RATES_TABS.FUTURE,
                children: <PenaltyRates type={PENALTY_RATES_TABS.FUTURE} forceToOpenTab={this.forceToOpenTab} />,
              },
            ]}
          />
          {baseErrors.length > 0 && (
            <Col xs={24} className="baseError">
              {baseErrors}
            </Col>
          )}
        </LayoutContentWithHeader>
      </Wrapper>
    );
  }
}

export default connect(
  state => ({
    data: state.Sector,
  }),
  dispatch => ({
    loadSectorPenaltyRates: /* istanbul ignore next */ data => dispatch(actions.loadSectorPenaltyRates(data)),
    shouldForceChangePenaltyRateTab: /* istanbul ignore next */ () =>
      dispatch(actions.shouldForceChangePenaltyRateTab()),
  }),
)(withRouter(PenaltyRatesSection));
